import {getTimezone} from "~/src/resources/utils/dateUtils";
import {getUserSettingBool} from "~/src/resources/users";

export const buildStreamRequest = ({
  currentRequest,
  sessionId,
  user,
  aiPermissions,
  trustedAdvisorModelProfile,
  responseWorkflowName,
  fullMessageContext,
  formToolsEnabled,
  allowedUiFormFields,
  allowedListTools,
}) => currentRequest.frozenRequest || {
  prompt: currentRequest.prompt,
  email: user.email,
  messageId: currentRequest.messageId,
  sessionId,
  agentTaskId: currentRequest.agentTaskId,
  allowInternetAccess: aiPermissions?.trustedAdvisorInternetAccess || false,
  docIds: currentRequest.docIds,
  attachments: currentRequest.attachments,
  modelProfile: trustedAdvisorModelProfile,
  responseWorkflowName: responseWorkflowName?.upper,
  skipReadOnlyConfirmation:
    !!aiPermissions?.trustedAdvisorPlatformToolsSkipReadOnlyConfirmation,
  timezone: getTimezone(),
  trustedAdvisorPlatformTools: aiPermissions?.trustedAdvisorPlatformTools || false,
  trustedAdvisorDocumentUpload: aiPermissions?.trustedAdvisorDocumentUpload || false,
  trustedAdvisorDocumentGeneration:
    aiPermissions?.trustedAdvisorDocumentGeneration || false,
  orgMemoryEnabled: aiPermissions?.memoryEnabled || false,
  userMemoryOrgEnabled: aiPermissions?.userMemoryOrgEnabled || false,
  wantsUserMemoryDisabled: getUserSettingBool(user, "wantsUserMemoryDisabled", false),
  userAgent: navigator.userAgent,
  userName: user?.nickname || user?.fullName,
  messageContext: fullMessageContext,
  formToolsEnabled,
  allowedUiFormFields,
  allowedListTools,
  ...(currentRequest.widgetType && {
    widgetType: currentRequest.widgetType,
    widgetValue: currentRequest.widgetValue,
    widgetLabel: currentRequest.widgetLabel,
  }),
};
